var React = require('react');

function RightArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2086 11.7132C19.2688 12.5062 19.2688 13.7942 18.2086 14.5872L4.63712 24.7383C3.57686 25.5314 1.85498 25.5314 0.794713 24.7383C-0.265555 23.9453 -0.265555 22.6573 0.794713 21.8643L12.4492 13.147L0.803195 4.42976C-0.257073 3.63671 -0.257073 2.34878 0.803195 1.55573C1.86346 0.762674 3.58534 0.762674 4.64561 1.55573L18.217 11.7068L18.2086 11.7132Z","fill":"#36373A"}));
}

RightArrow.defaultProps = {"width":"19","height":"26","viewBox":"0 0 19 26","fill":"none"};

module.exports = RightArrow;

RightArrow.default = RightArrow;
